import { useRouter } from 'next/router';
import React from 'react';
import { FindBtn } from '../SearchNameSection/styled';
import { NameBox, NameList, ViewButton, WhiteCard } from './styled';
import Link from 'next/link';
import {
  createRippleEffectRelative,
  removeDefaultParams,
} from '../../../../Utils/helper';
import {
  clickedCtaEvent,
  clickedSectionEvent,
} from '../../instrumentation/instrumentation';
import { SVGBabyNames } from '../../../../Svg/BabyNamesPage';

export default function UniqueNameCard(props) {
  const { redirect, heading, names, home, headingName } = props;

  const router = useRouter();

  const clickHandler = (data, e) => {
    clickedSectionEvent(home, headingName, data?.id, data?.name);
    e.preventDefault();
    window.location =
      `/parenting/babynames/meaning-of-${data?.name?.toLowerCase()}-${
        data?.id
      }` + window.location.search;
  };

  return (
    <WhiteCard>
      <NameBox>
        {names?.map((data, index) => {
          return (
            <Link
              key={`unique${index}`}
              href={{
                pathname: `/parenting/babynames/meaning-of-${data?.name?.toLowerCase()}-${
                  data?.id
                }`,
                query: removeDefaultParams(router.query),
              }}
              passHref
              locale={false}
              legacyBehavior
            >
              <NameList as="a" onClick={(e) => clickHandler(data, e)}>
                {data?.gender == 'Boy' ? (
                  <SVGBabyNames id="male" />
                ) : (
                  <SVGBabyNames id="female" />
                )}
                {data?.name}
              </NameList>
            </Link>
          );
        })}
      </NameBox>
      <ViewButton>
        <Link
          href={{
            pathname: `/parenting/babynames/unique-baby-names/${heading}`,
            query: removeDefaultParams(router.query),
          }}
          passHref
          locale={false}
        >
          <FindBtn
            id={'babyViewAll' + heading}
            onClick={(event) => {
              createRippleEffectRelative(
                event,
                document.getElementById('babyViewAll' + heading),
              );
              // redirect(heading);
              clickedCtaEvent(home, headingName, 'View All');
            }}
            // onClick={() => {
            //     redirect(heading);
            // }}
          >
            View All
          </FindBtn>
        </Link>
      </ViewButton>
    </WhiteCard>
  );
}
